export default __webpack_public_path__ + "static/media/delete.94bd51c7.svg";